// extracted by mini-css-extract-plugin
module.exports = {"voucherControls":"PromoCodeControls_voucherControls__mDA00","applyButton":"PromoCodeControls_applyButton__StSr9"};